@if ($configSchema() != null) {
    <div class="form-group mt-4">
        <h5>Configurações do E-Docs</h5>
        <hr class="mt-0 mb-4" />
    </div>

    <div class="form-group mt-4">
        <h6>
            <span featureHint="flowObjectDetails|DocumentClass" featureHintHAlign="right">Classificação Documental</span>
        </h6>
    </div>

    <!-- Classificação Documental -->
    <document-class [_model]="$configSchemaSectionDocumentClass()"
                    [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                    [_isReadOnlyMode]="$isReadOnlyMode()"
                    (_modelChange)="onUpdateDocumentClass($event)"
    ></document-class>

    <div class="form-group mt-4">
        <h6>
            <span featureHint="flowObjectDetails|AccessLevel" featureHintHAlign="right">Nível de Acesso do Documento</span>
        </h6>
    </div>

    <!-- Nível de Acesso -->
    <access-level #accessLevelRef
                  [_model]="$configSchemaSectionAccessLevel()"
                  [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                  [_isReadOnlyMode]="$isReadOnlyMode()"
                  (_modelChange)="onUpdateAccessLevel($event)"
    ></access-level>
}
